import { render, staticRenderFns } from "./BatchSync.vue?vue&type=template&id=78ec256e&scoped=true"
import script from "./BatchSync.vue?vue&type=script&lang=js"
export * from "./BatchSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec256e",
  null
  
)

export default component.exports